import { HttpClient } from "@angular/common/http";
import {Component,ElementRef,OnInit, ViewChild} from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import * as moment from "moment";
import { Subject } from "rxjs";
import { EncryptionService } from "src/app/_services/encryption.service";
import { ExcelService } from "src/app/_services/excel.service";
import { MentorshipDashboardService } from "src/app/_services/mentorship-dashboard.service";

declare const $: any;

class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Component({
    selector: 'app-mentee-ratings',
    templateUrl: './mentee-ratings.component.html'
})


export class MenteeRatingsComponent implements OnInit{
  @ViewChild("datePicker", { static: false }) datePicker: ElementRef;
   startDate: any = '';
   endDate: any = '';
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  exportMenteeList: any = [];
  fieldsToIncludeExcel: any = [];
  exl: boolean = false;
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };
  dtTrigger = new Subject();
  menteeRatingsList: any = []; 
  isSubmitted = false;
  dateInvalid: boolean = false;
  today: string = ''

  constructor(
    public router: Router,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private excelService: ExcelService,
    private dataService: MentorshipDashboardService,
    
  ) {
    const now = new Date();
    this.today = now.toISOString().split('T')[0];
  }


  totalMenteeRatings: any;
  modalReference: NgbActiveModal;
  modalCropper: NgbActiveModal;

  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);
    const strtDate = sessionStorage.getItem('startDate');
        const endDate = sessionStorage.getItem('endDate');
        this.startDate = strtDate;
        this.endDate = endDate;
    this.getListing() 
    this.menteeRatingsListing()
  }

getListing() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        const data = {
          "type" : 'avg_rating_mentee',
          "export": false,
         "start_date": this.startDate,
            "end_date": this.endDate
      }
        const requestPayload = {
          ...dataTablesParameters,
          ...data, 
        };
  
        const encryptedData = this.enc_dec.encrypt(JSON.stringify(requestPayload));
  
        this.http
          .post<DataTablesResponse>(
            '/api/metric-list',
            { req_data: encryptedData },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
  
            this.menteeRatingsList = resp['data'];
            this.totalMenteeRatings = resp['recordsTotal'];
  
            callback({
              recordsTotal: resp['recordsTotal'],
              recordsFiltered: resp['recordsFiltered'],
              data: [], 
            });
          });
        },
      columns: [
        { data: 'id' },
        { data: 'name' },
        { data: 'meeting_topic' },
        { data: 'rating' },
        { data: 'created_at' },
      ],
    };
  }
  
  onSearch() {
    this.isSubmitted = true;
    this.dateInvalid = false;
  
    if (!this.startDate || !this.endDate) {
      return;
    }
  
    const start = new Date(this.startDate);
    const end = new Date(this.endDate);
  
    if (start > end) {
      this.dateInvalid = true;
      return;
    }
    const table = $("#mentee_ratings").DataTable();
    table.ajax.reload(null, false);
    this.menteeRatingsListing()
  
  }  


  menteeRatingsListing() {
    const data =  {
        "draw": 1,
        "start": 0,
        "length": 1,
        "order": [
            {
                "column": 0,
                "dir": "asc"
            }
        ],
        "search": {
            "value": "",
            "regex": false
        },
        "start_date":this.startDate,
      "end_date": this.endDate,
        "export": true,
        "type": "avg_rating_mentee"
    }
        

    this.loadShow();
    this.dataService
      .dataExport(data)
      .pipe()
      .subscribe((res) => {
          this.exportMenteeList = res["data"];
          this.fieldsToIncludeExcel = [
            "name",
            "meeting_topic",
            "rating",
            "created_at",
           
          ];
          this.exl = true;
     
        this.loadHide();
      });
  }

  
    
    onReset() {
      this.isSubmitted = false;
      this.startDate = ''
      this.endDate = ''
      sessionStorage.removeItem('startDate');
      sessionStorage.removeItem('endDate');
        const table = $("#mentee_ratings").DataTable();
        table.ajax.reload(null, false);
        this.menteeRatingsListing()
    }
  


  exportToExcel() {
    this.excelService.generateExcel(
      this.exportMenteeList,
      this.fieldsToIncludeExcel,
      "Mentee Ratings"
    );
  }

  
  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }


   ngAfterViewInit(): void {
    this.dtTrigger.next();
    $('#mentee_ratings').on('page.dt', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' 
      });
    });
  }

   ngOnDestroy(): void {
     $('#mentee_ratings').off('page.dt');
    this.dtTrigger.unsubscribe();
  }

  
      blockTyping(event: KeyboardEvent) {
        event.preventDefault();
      }



  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
